import { site } from './globals';

const getDocumentProperties = () => {
    let isDesktop = false;
    let isTablet = false;
    let isMobile = false;
    const vw = document.documentElement.clientWidth || window.innerWidth;
    if (vw >= site.size.desktop) {
        isDesktop = true;
    } else if (
        vw <= site.size.desktop &&
        vw >= site.size.tablet
    ) {
        isTablet = true;
    } else {
        isMobile = true;
    }

    return {
        mobile: isMobile,
        tablet: isTablet,
        desktop: isDesktop
    }
}

export {
    getDocumentProperties
}
